// import React from "react";
import { Route, Routes } from "react-router-dom";

import { useDocument } from "../../../../firebase-files/hooks/useDocument";
import PlantationOneFooter from "../../../environment/environmentOne/plantationOneComponents/PlantationOneFooter";
import Navbar from "../../../../default-components/Navbar";
import PlantationOneHome from "../../../environment/environmentOne/plantationOnePages/PlantationOneHome";
import BusinessThreeNavbar from "../../../business/businessThree/businessThreeComponents/BusinessThreeNavbar";
import GlobalRoute from "../../../../global route/GlobalRoute";
import PlantationOneDashboard from "../../../environment/environmentOne/plantationOnePages/PlantationOneDashboard";
import AdoptedTreeDetails from "../../../environment/environmentOne/plantationOnePages/AdoptedTreeDetails";
import PGEcomTwoHome from "../ecomTwoPages/PGEcomTwoHome";

const EcomTwoRoute = () => {
  const { document: navTypeDoc } = useDocument("settings", "navbarType");
  return (
    <div className="plantation_one_route_parent">
      {navTypeDoc && navTypeDoc.activeNav === "FixNav" ? (
        <Navbar />
      ) : (
        <BusinessThreeNavbar />
      )}

      <Routes>
        <Route path="/" element={<PGEcomTwoHome />} />
        {/* <Route path="/aboutus" element={<PGAboutUs />} /> */}
        <Route path="/my-plants" element={<PlantationOneDashboard />} />
        <Route
          path="/my-plants/:orderId/:slug/:plantId"
          element={<AdoptedTreeDetails />}
        />
      </Routes>
      <GlobalRoute />
      <PlantationOneFooter />
    </div>
  );
};

export default EcomTwoRoute;
